export default "::ng-deep .WrappedColumnClass{white-space:normal;word-wrap:break-word}";